import {testimonial} from '@/api-services'
import {errorHandler, successHandler} from '@/utils/handler'
import {toast} from '@/utils/toast'
import {defineStore} from 'pinia'

export const useTestimonialStore = defineStore('testimonialStore', {
  state: () => ({
    allTestimonials: [],
    getTestimonial: {},
    getTestimonialLoading: false,
    loading: false,
    error: null,
  }),
  getters: {
    getSlicedTestimonials() {
      return this.allTestimonials.slice(0, 4)
    },
  },
  actions: {
    async getAllTestimonials() {
      this.loading = true
      try {
        const response = await testimonial.get()
        const data = response.data
        this.allTestimonials = data
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async deleteTestimonial(id) {
      this.loading = true
      try {
        await testimonial.delete(id)
        toast.success(successHandler('DELETE_SUCCESS'))
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async createTestimonial(payload) {
      const formData = new FormData()
      formData.append('position', payload.position)
      formData.append('name', payload.name)
      formData.append('title', payload.title)
      formData.append('description', payload.description)
      if (payload.image) {
        formData.append('image', payload.image)
      }
      this.loading = true
      try {
        const response = await testimonial.create(formData)
        this.getTestimonial = response.data
        toast.success(successHandler('CREATE_TESTIMONIAL_SUCCESS'))
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async updateTestimonial(payload, id) {
      const formData = new FormData()
      formData.append('position', payload.position)
      formData.append('name', payload.name)
      formData.append('title', payload.title)
      formData.append('description', payload.description)
      if (payload.image) {
        formData.append('image', payload.image)
      }
      this.loading = true
      try {
        const response = await testimonial.update(formData, id)
        this.getTestimonial = response.data
        toast.success(successHandler('UPDATE_TESTIMONIAL_SUCCESS'))
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async getTestimonialById(id) {
      this.getTestimonialLoading = true
      try {
        const response = await testimonial.getById(id)
        const data = response.data
        this.getTestimonial = data
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.getTestimonialLoading = false
      }
    },
  },
})
